module.exports = __webpack_public_path__ + "img/system_cn_hover.75f5042e.png";